module.exports = __webpack_public_path__ + "static/droneImg-67ac0d990c4df2f5a586d005653c84ff.jpeg";